import { RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY } from '@/utils/constants/rfp/rfpOfferMember/memberType';
export const fileDefaultValue = {
    file: undefined,
    id: null,
    name: '',
    new_file_id: null,
    path: '',
};
export const additionalFileDefaultValue = {
    file: undefined,
    id: null,
    name: '',
    new_file_id: undefined,
    path: '',
    uniqId: '',
};
export const memberDefaultValue = {
    email: '',
    first_name: '',
    involvement: null,
    last_name: '',
    member_type: RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY.value,
    role: null,
};
export const offerFormPublicDefaultValues = {
    assign: false,
    is_draft: false,
    offer: {
        additional_files: [],
        candidate_interview_date: '',
        file: fileDefaultValue,
        free_description: '',
        period: null,
        price: null,
        summary: '',
    },
    rfp_offer_members: [],
};
export const offerFormDirectDefaultValues = {
    assign: false,
    is_draft: false,
    offer: {
        additional_files: [],
        answer: '',
        candidate_interview_date: '',
        max_period: null,
        max_price: null,
        period: null,
        price: null,
    },
    rfp_offer_members: [],
};
